export default {
  List: {
    Columns: {
      JobTitleName: "Tên chức vụ/chức danh",
      Description: "Mô tả",
      Created: "Ngày tạo",
    },

    SearchText: "Tìm theo tên chức vụ/chức danh",
    AddJobtitle: "Thêm chức vụ/chức danh",
    ImportJobTitle: "Nhập khẩu"
  },
  Detail: {
    AddTitle: "Thêm chức vụ/chức danh",
    EditTitle: "Sửa chức vụ/chức danh",
    JobTitleName: "Tên chức vụ/chức danh",
    Description: "Mô tả",
    Input: {
      JobTitleName: "Nhập tên chức vụ/chức danh",
      Description: "Nhập mô tả",
    }
  },
  Message: {
    AddSuccess: "Thêm chức vụ/chức danh thành công",
    EditSuccess: "Sửa chức vụ/chức danh thành công",
    DeleteSuccess: "Xóa chức vụ/chức danh thành công",
    Duplicate: "Tên chức vụ/chức danh đã tồn tại. Vui lòng thiết lập tên chức vụ/chức danh khác",
    SaveFail: "Lưu không thành công",
    ConfirmDelete: "Chức vụ/Chức danh <b>{0}</b> sẽ bị xóa khỏi hệ thống. Bạn có muốn tiếp tục?",
    ConfirmDeleteMulti: "Những chức vụ/chức danh đã chọn sẽ bị xóa khỏi hệ thống. Bạn có muốn tiếp tục?",
    DeleteTitle: "Xóa chức vụ/chức danh",
  }
}